<template>
  <component :is="tag" class="TypographyMeta">
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'p'
    }
  }
}
</script>

<style lang="scss">
@import './src/assets/styles/colors.scss';
@import './src/assets/styles/fonts.scss';
@import './src/assets/styles/mixins.scss';

.TypographyMeta {
  display: flex;
  flex-wrap: wrap;
  margin-top: 4px;
  color: $color-pale-sky;
  font-family: $font-secondary;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.43;

  strong {
    position: relative;
    z-index: 1;

    &:before {
      content: '';
      position: absolute;
      top: -2px;
      right: -5px;
      bottom: -2px;
      left: -2px;
      z-index: -1;
      background-color: $color-porcelain;
      pointer-events: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/typography/TypographyMeta.vue